export const NoOp: Spintr.NoOp = () => { /* ignored */ };